import Scrollbar from 'smooth-scrollbar';
import Resize from 'throttled-resize';
import Kernel from './Kernel';

export class SmoothScrolling extends Kernel {
    constructor (target) {
        console.log('Module: SmoothScrolling has been loaded');

        super(target);

        this.scrollbar = Scrollbar;
        this.isSmooth = false;
        this.isMobile = true;

        if (window.matchMedia('(min-width: 1224px)').matches)
        {
            this.buildSmoothScrolling();
            this.isSmooth = true;
            this.isMobile = false;

            this.$document.on('SmoothScrolling.rebuild', () => {
                this.updateElements();
            });
        }

        else if (window.matchMedia('(max-width: 1223px)'))
        {
            this.mobileScrolling();
        }

        const resize = new Resize();
        resize.on('resize:end', () => this.checkResize());
    }

    mobileScrolling () {
        this.$window.on('scroll.SmoothScrolling', () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            this.toggleHeader(scrollTop);
        });


        $('.js-scroll-to').on('click.SmoothScrolling', (e) => {
            e.preventDefault();

            const $el = $(e.currentTarget);
            const target = $el.data('target') ? $el.data('target') : $el.attr('href');
            const offset = $(target).offset().top;

            $('html, body').animate({
                scrollTop: offset
            }, 750);
        });
    }

    buildSmoothScrolling () {
        let _this = this;

        setTimeout(() => {
            this.selector = '.js-parallax';
            this.scrollbar = Scrollbar.init(this.$el[0]);
            this.windowHeight = this.$window.height();
            this.windowMiddle = this.windowHeight / 2;
            this.scrollbarLimit = this.scrollbar.limit.y + this.windowHeight;
            this.elements = {};
            this.addElements();
            this.checkElements(true);
            _this.scrollbar.addListener(function (status) {
                _this.toggleHeader(status.offset.y);
                return _this.checkElements();
            });
            $('.js-scroll-to').on('click.SmoothScrolling', (e) => {
                this.scrollTo(e);
            });
            this.$document.trigger('SmoothScroll.isReady');
        }, 300);
    }

    addElements () {
        $(this.selector).each((i, e) => {
            const $element = $(e);
            const speed = $element.data('speed') / 10;
            const position = $element.data('position');
            const target = $element.data('target');
            const horizontal = $element.data('horizontal');
            const persist = $element.data('persist');
            const $target = target ? $(target) : $element;

            let offset = $target.offset().top + this.scrollbar.scrollTop;

            if (!$target && $element.data('transform'))
            {
                const transform = $element.data('transform');
                offset -= parseFloat(transform.y);
            }

            const limit = offset + $target.outerHeight();
            const middle = ((limit - offset) / 2) + offset;

            this.elements[i] = {$element, offset, limit, middle, speed, position, horizontal, persist};
        });
    }

    toggleHeader(scroll) {
        const $parent = this.$body.find('.js-header');
        const parentHeight = $parent.outerHeight();

        if (scroll >= parentHeight / 2)
        {
            this.$html.addClass('has-scrolled');
        }
        else
        {
            this.$html.removeClass('has-scrolled');
        }
    }


    updateElements () {
        this.scrollbar.update();
        this.windowHeight = this.$window.height();
        this.windowMiddle = this.windowHeight / 2;
        this.scrollbarLimit = this.scrollbar.limit.y + this.windowHeight;
        this.elements = {};
        this.addElements();
        this.checkElements(true);
        this.$document.trigger('SmoothScroll.update');
    }

    checkResize () {
        if (window.matchMedia('(min-width: 1224px)').matches)
        {
            this.$window.off('.SmoothScrolling');

            if (this.isSmooth)
            {
                this.updateElements();
            }
            else
            {
                this.isMobile = false;
                this.isSmooth = true;
                this.buildSmoothScrolling();
            }
        }
        else if (this.isSmooth)
        {
            this.isMobile = true;
            this.isSmooth = false;
            this.destroy();
        }
    }

    checkElements (param) {
        const scrollTop = this.scrollbar.scrollTop;
        const scrollbarLimit = this.scrollbar.scrollbarLimit;
        const scrollLimit = scrollTop + this.windowHeight;
        const scrollMiddle = scrollTop + this.windowMiddle;

        for (const element of Object.keys(this.elements))
        {
            const {$element, offset, limit, middle, speed, position, horizontal, persist} = this.elements[element];
            const height = position === 'top' ? scrollTop : scrollLimit;
            const inView = height >= offset && scrollTop <= limit;

            if (inView)
            {
                $element.addClass('is-inview');

                if (persist)
                {
                    $element.addClass('is-visible');
                }
            }
           /* else
            {
                $element.removeClass('is-inview');
            }*/

            let value = '';

            if (param && !inView && speed && position !== 'top')
            {
                value = (offset - this.windowMiddle - middle) * -speed;
            }

            if (inView && speed)
            {
                switch (position)
                {
                    case 'top':
                        value = (scrollTop - offset) * -speed;
                        break;
                    case 'bottom':
                        value = (scrollbarLimit - height) * speed;
                        break;
                    default:
                        value = (scrollMiddle - middle) * -speed;
                }
            }

            if (value)
            {
                if (typeof horizontal !== 'undefined')
                {
                    this.transform($element, value + 'px');
                }
                else
                {
                    this.transform($element, 0, value + 'px');
                }
            }
        }
    }

    transform ($element, x = 0, y = 0, z = 0) {
        $element.css({
            '-webkit-transform': `translate3d(${x}, ${y}, ${z})`,
            '-ms-transform': `translate3d(${x}, ${y}, ${z})`,
            transform: `translate3d(${x}, ${y}, ${z})`
        }).data('transform', {x, y, z});

        $element.find(this.selector).each((a, e) => {
            const $el = $(e);

            if ($el.data('transform'))
            {
                $el.data('transform', {x, y, z});
            }
        });
    }

    scrollTo (event) {
        let offset;

        if ($.isNumeric(event))
        {
            offset = event;
        }
        else
        {
            event.preventDefault();

            const $el = $(event.currentTarget);
            const target = $el.data('target') ? $el.data('target') : $el.attr('href');
            console.log(target);

            offset = ($(target).offset().top + this.scrollbar.scrollTop) - this.headerHeight;
        }

        this.scrollbar.scrollTo(0, offset, 1500);
    }

    destroy () {
        console.log('%cModule: SmoothScrolling has been destroyed', 'color: red;');

        this.$window.off('.SmoothScrolling');
        this.$el.off('.SmoothScrolling');

        this.element = {};
        this.selector = null;

        if (this.isMobile)
        {
            this.scrollbar.destroy();
        }
    }
}

export default SmoothScrolling;



// WEBPACK FOOTER //
// ./app/src/js/modules/SmoothScrolling.js